// extracted by mini-css-extract-plugin
export var half = "styles-module--half--54dfb";
export var hr = "styles-module--hr--15a4b";